import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getUserProfile } from '../api/appApi';

const PrivateRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem('access_token');
  useEffect(() => {
    if (!token) {
      setIsValid(false);
      return;
    }

    const checkToken = async () => {
      try {
        const response = await getUserProfile(token);

        if (response?.success) {
          setIsValid(true);
          const user = {
            email: response?.data.email
          }
          localStorage.setItem('user_details', JSON.stringify(user));
        } else {
          localStorage.removeItem('access_token'); // cleanup
          setIsValid(false);
        }
      } catch (error) {
        localStorage.removeItem('access_token');
        setIsValid(false);
      }
    };

    checkToken();
  }, [token]);

  // Show loader while checking token
  if (isValid === null) {
    return <div className="page-loader"><span className="spinner-border" /></div>;
  }

  return isValid ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
